// extracted by mini-css-extract-plugin
module.exports = {"detail":"Description_detail__4rGP5","text":"Description_text__LcZwg","title":"Description_title__cwYAk"};